import { render, staticRenderFns } from "./ArnicaV2.vue?vue&type=template&id=551d0d6e&scoped=true"
import script from "./ArnicaV2.vue?vue&type=script&lang=ts"
export * from "./ArnicaV2.vue?vue&type=script&lang=ts"
import style0 from "./ArnicaV2.vue?vue&type=style&index=0&id=551d0d6e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551d0d6e",
  null
  
)

export default component.exports